/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Sidebar_Multiselect_TitleInputs */

const es_walkthrough_sidebar_multiselect_title = /** @type {(inputs: Walkthrough_Sidebar_Multiselect_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección Múltiple de Chats`)
};

const en_walkthrough_sidebar_multiselect_title = /** @type {(inputs: Walkthrough_Sidebar_Multiselect_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-Select Threads`)
};

/**
* | output |
* | --- |
* | "Multi-Select Threads" |
*
* @param {Walkthrough_Sidebar_Multiselect_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_sidebar_multiselect_title = /** @type {((inputs?: Walkthrough_Sidebar_Multiselect_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Sidebar_Multiselect_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_sidebar_multiselect_title(inputs)
	return en_walkthrough_sidebar_multiselect_title(inputs)
});
export { walkthrough_sidebar_multiselect_title as "walkthrough.sidebar_multiselect_title" }